import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

/**
 * Guard that prevents authenticated users from accessing routes intended for guests only
 * (e.g., login and registration pages). If a user is already logged in, they will be
 * redirected to the home page.
 */
@Injectable()
export class GuestOnlyGuard  {
    constructor(private auth: AuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.auth.isAuthenticated()) {
            // User is already logged in, redirect to home page
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }

}

